import React, { Component } from 'react';

class Slider extends Component {
    sliderStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    };

    sliderBarStyle = {
        width: '20px',
        height: '10px',
        borderRadius: 'var(--rounded-border)',
        marginRight: '5px',
        cursor: 'pointer'
    };

    sliderBarEmptyStyle = {
        ...this.sliderBarStyle,
        border: 'var(--normal-light-gray-border)'
    };

    sliderBarFullStyle = {
        ...this.sliderBarStyle,
        backgroundColor: 'var(--blue)',
        border: 'var(--normal-blue-border)'
    };

    percentageStyle = {
        // width: '40px',
        // height: '40px',
        // borderRadius: 'var(--rounded-border)',
        // backgroundColor: 'var(--light-blue)',
        color: 'var(--darker-gray)',
        fontSize: '21',
        fontWeight: '500',
        textAlign: 'center',
        marginLeft: '5px'
    };

    onSliderBarClick(i) {
        this.props.updatePrecentage(i);
    }

    barsFull() {
        let full = this.props.percentage / 10;
        return this.getBarsArray(full, 1, 10);
    }

    // barsPartial() {
    //     let
    // }

    barsEmpty() {
        // Changing to nearest 10.
        let full = Math.ceil(this.props.percentage / 10);
        let empty = 10 - full;
        return this.getBarsArray(empty, full + 1, 0);
    }

    getBarsArray(numberOfBars, startIndex, fill) {
        let bars = [];
        for (let j = 0; j < numberOfBars; j++) {
            bars.push({ index: startIndex + j, value: fill });
        }
        return bars;
    }

    individualBar(bar, style) {
        // A read-only slider shows the weight and takes no clicks
        const { readOnly } = this.props;

        return (
            <div
                key={bar.index}
                style={readOnly ? { ...style, cursor: 'default' } : style}
                title={bar.index * 10 + '%'}
                onClick={
                    readOnly
                        ? undefined
                        : () => this.props.updatePercentage(bar.index * 10)
                }
            />
        );
    }

    render() {
        return (
            <div style={this.sliderStyle}>
                {this.barsFull().map(bar =>
                    this.individualBar(bar, this.sliderBarFullStyle)
                )}
                {this.barsEmpty().map(bar =>
                    this.individualBar(bar, this.sliderBarEmptyStyle)
                )}
                <div style={this.percentageStyle}>{this.props.percentage}%</div>
            </div>
        );
    }
}

export default Slider;
